import React from 'react'
import "../stylings/bannerImage.css"
import { Link, useLocation } from 'react-router-dom'

const routeLabels = {
    '/about-school':                'About School',
    '/public-disclosure':           'Mandatory Public Disclosure',
    '/cbse-mandatory-public-disclosure': 'CBSE Mandatory Disclosure',
    '/contact':                     'Contact Us',
    '/syllabus':                    'Syllabus',
    '/time-table':                  'Time Table',
    '/academic-calender':           'Academic Calendar',
    '/noticeall':                   'Notice Board',
    '/audionoticeall':              'Audio Announcements',
    '/galleryall':                  'Photo Gallery',
    '/videoall':                    'Video Gallery',
    '/chairman-message':            'Chairman\'s Message',
    '/principal-message':           'Principal\'s Message',
    '/manager-message':             'Manager\'s Message',
    '/login':                       'Login',
}

const BannerImage = () => {
    const location = useLocation()
    const label = routeLabels[location.pathname] || 'Welcome'

    return (
        <div className="page-banner">
            <div className="container">
                <div className="banner-inner">
                    <h1>{label}</h1>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item active">{label}</li>
                    </ol>
                </div>
            </div>
        </div>
    )
}

export default BannerImage
